import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import AppDialog from '../AppDialog';

export default function ConfirmReserveRequestModal(props) {
    const { open, storageUnit, close, handleConfirm, loading } = props;

    return (
        <AppDialog
            open={open}
            onClose={close}
            title={`Reserve ${storageUnit?.name ?? ''}`}
            onSubmit={handleConfirm}
            submitText={loading ? 'Requesting...' : 'Confirm'}
            busy={loading}
        >
            <Typography>
                Would you like to request to reserve Storage Unit {storageUnit?.name}?
            </Typography>
        </AppDialog>
    );
}

ConfirmReserveRequestModal.propTypes = {
    storageUnit: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }),
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};